module.exports = __webpack_public_path__ + "../resources/images/OneNote-864aaefa5ea4b1336405a45eb1ba133b.svg";